module.exports = __webpack_public_path__ + "img/submit-nomal.9301e224.png";